import { List, ListItem, ListItemText } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import { NavLink } from 'react-router-dom'

/**
 * Training hidden from the nav (2026-08-27): no facility runs it. Routes/pages/API stay intact
 * and URL-reachable — flip to true to restore.
 */
const SHOW_TRAINING = false

const useStyles = makeStyles((theme) => ({
	listItem: {
		fontFamily: 'Nunito',
		fontSize: 16,
		color: '#3B0275',
		opacity: 0.6,
		fontWeight: 'bold !important'
	}
}))

const FacilitySetupNavItems = (props) => {
	const { selectedFacility } = props
	const classes = useStyles()

	return (
		<List className={classes.defaultNav}>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/facilitySetup/basicInfo`}>
				<ListItemText primary="Basic Info" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/facilitySetup/memberships`}>
				<ListItemText primary="Memberships" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/facilityMarketing/events`}>
				<ListItemText primary="Facility Marketing" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/facilitySetup/holidays`}>
				<ListItemText primary="Holidays" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/facilitySetup/capacity`}>
				<ListItemText primary="Capacity" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${
					selectedFacility ? selectedFacility._id : null
				}/facilityBooking/daycare/booking`}>
				<ListItemText primary="Daycare" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${
					selectedFacility ? selectedFacility._id : null
				}/facilityBooking/boarding/booking`}>
				<ListItemText primary="Boarding" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${
					selectedFacility ? selectedFacility._id : null
				}/facilityBooking/grooming/booking`}>
				<ListItemText primary="Grooming" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${
					selectedFacility ? selectedFacility._id : null
				}/facilityBooking/compatibility/booking`}>
				<ListItemText primary="Compatibility Sessions" />
			</ListItem>
			{SHOW_TRAINING && (
				<ListItem
					component={NavLink}
					className={classes.listItem}
					to={`/facilities/${selectedFacility ? selectedFacility._id : null}/training/setup/booking`}>
					<ListItemText primary="Training" />
				</ListItem>
			)}
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/facilitySetup/petCareSetup`}>
				<ListItemText primary="Pet Care Setup" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${
					selectedFacility ? selectedFacility._id : null
				}/facilitySetup/availablePlaygroups`}>
				<ListItemText primary="Available Playgroups" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/facilitySetup/kennels`}>
				<ListItemText primary="Kennels" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/facilitySetup/activitySetup`}>
				<ListItemText primary="Activity Setup" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/facilitySetup/addons`}>
				<ListItemText primary="Enrichment Availability" />
			</ListItem>
			<div style={{ height: 600, width: 10 }}></div>
		</List>
	)
}

export default FacilitySetupNavItems
